var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, property, customElement, css } from 'lit-element';
import CSTStyles from '../../styles/cst-styles/cst-styles';
export class BasicSnackbar {
    constructor() {
        this._isComponent = false;
    }
    open(message) {
        void message;
        console.warn('Missing import of cst-banner');
    }
}
export let CSTSnackbarSingleton = new BasicSnackbar();
let CSTSnackbarElement = class CSTSnackbarElement extends LitElement {
    constructor() {
        super();
        this.message = '';
        this._isComponent = true;
        if (!CSTSnackbarSingleton || !CSTSnackbarSingleton._isComponent) {
            CSTSnackbarSingleton = this;
        }
        else {
            console.warn('More than one cst-banner-element has been used in this web application, consider removing one.');
        }
    }
    close() {
        if (!this.opened) {
            return;
        }
        this.opened = false;
        this._resolve();
    }
    open(message) {
        return new Promise(resolve => {
            clearTimeout(this._closeTimeoutHandle);
            if (message) {
                this.message = message;
            }
            this._resolve = resolve;
            this.opened = true;
        });
    }
    render() {
        return html `
      <section ?opened=${this.opened}>
        <small>${this.message}</small>
        <a
          class="button"
          @click=${e => {
            e.preventDefault();
            clearTimeout(this._closeTimeoutHandle);
            this.close();
        }}
          >Ok</a
        >
      </section>
    `;
    }
};
CSTSnackbarElement.styles = css `
    ${CSTStyles} :host {
      max-width: 280px;
      position: absolute;
      right: 16px;
      top: 71px;
    }

    @keyframes fadeIn {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }

    section {
      display: none;
      align-items: center;
      padding: 16px;
      border: 1px solid #eee;
      border-radius: 8px;
      background: #fff;
      box-shadow: 2px 2px 8px #eee;
    }

    section[opened] {
      animation: 0.3s fadeIn ease;
      display: flex;
    }

    a.button {
      user-select: none;
      margin: 0 0 0 16px;
    }
  `;
__decorate([
    property({ type: String })
], CSTSnackbarElement.prototype, "message", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], CSTSnackbarElement.prototype, "opened", void 0);
CSTSnackbarElement = __decorate([
    customElement('cst-snackbar')
], CSTSnackbarElement);
export default CSTSnackbarElement;
//# sourceMappingURL=cst-snackbar.js.map